import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendRequest,
  requestFinished
} from '../../../../common/reducers/forms/resendConfirmTokenAction';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* resendChangeEmailConfirmTokenActionSaga(reducerName) {
  try {
    const response = yield call(
      timeoutCall,
      UserService.resendChangeEmailConfirmToken
    );
    if (response) {
      if (response.status === 200) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: response.data.message
          })
        );
      }
    }
    yield put(
      requestFinished(reducerName, response.status, response.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      resendChangeEmailConfirmTokenActionSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/resendChangeEmailConfirmTokenActionSaga.js